import React, {useRef, useState} from "react";
import classes from './Projects.module.scss'
import {useClickAwayListener} from "../../hooks/useClickAwayListener";
import {useKeyDownListener} from "../../hooks/useKeyDownListener";
import clsx from "clsx";
import {animated, useTransition} from "react-spring";
type Props = {
	image: string,
	heading: string,
	text: string,
	children?: JSX.Element | JSX.Element[],
	onOpen?: () => void
}

export const Project = (props: Props) => {
	const [open, setOpen] = useState(false);
	const ref = useRef<HTMLDivElement | null>(null);
	const transition = useTransition(open, null, {
		from: {
			opacity: 0
		},
		enter: {
			opacity: 1
		},
		leave: {
			opacity: 0
		},
		config: {
			friction: 20,
			tension: 300,
			clamp: true
		}
	})

	const onClickAway = () => {
		setOpen(false)
	}

	function onKeyDown(key: string) {
		if (key === 'Escape') {
			setOpen(false)
		}
	}

	useKeyDownListener(onKeyDown)
	useClickAwayListener(ref, onClickAway)

	return (
		<>
			<div className={clsx(classes.project)}
				 onClick={() => {
					 setOpen(true)
					 props.onOpen?.()
				 }}>
				<div
					className={classes.imageContainer}
					style={{
						backgroundImage: `url(${props.image})`
					}}
				>
					{/*<img alt={props.image} src={props.image}/>*/}
				</div>
				<h4>{props.heading}</h4>
				<p>{props.text}</p>
			</div>
			{transition.map((value) => value.item && (
				<animated.div className={classes.dialog} key={value.key} style={value.props}>
					<div ref={ref} className={classes.dialogWindow}>
						{props.children}
					</div>
				</animated.div>
			))}
		</>
	)
}